import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Toolstack from "./Toolstack";
import Cpstack from "./Cpstack";
import Tilt from "react-parallax-tilt";
import myImg from "../../Assets/Tarun_Profile.jpg";

function About() {
  return (
    <Container fluid className="about-section" id="about">
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={8}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 className="about-heading" style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              LET ME <strong className="purple">INTRODUCE</strong> MYSELF
            </h1>
            <Aboutcard />
          </Col>
          {/* Avatar — shown on desktop only (mobile sees it in Home hero) */}
          <Col
            md={4}
            style={{ paddingTop: "80px", paddingBottom: "50px" }}
            className="myAvtar d-none d-md-flex justify-content-center align-items-center"
          >
            <Tilt>
              <img
                src={myImg}
                className="img-fluid"
                alt="avatar"
                style={{
                  borderRadius: "20%",
                  width: "250px",
                  height: "250px",
                  objectFit: "cover",
                  objectPosition: "top",
                  boxShadow: "0 0 20px rgba(200, 137, 230, 0.4), 0 4px 30px rgba(0,0,0,0.3)",
                  border: "2px solid rgba(200, 137, 230, 0.3)"
                }}
              />
            </Tilt>
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <h1 className="project-heading">
          <strong className="purple">CP & DSA</strong> Profiles
        </h1>
        <Cpstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
